import React from 'react';
import {Context_role} from "../../context/rolesStore";
import {ADMIN_ROLE, NOTAVAILABLE} from '../../constants/global';
import {dateAndTimeFormatter} from '../../utils/utils';

const OrgDetail = ( {orgDetail}) => {
  const {state: {newroles} } = React.useContext(Context_role);

  return (
    <div>
      <div className='row cb-padding-left-48'>
        <div className='cb-margin-top-8'>
            <div>
              <h2 className='cb-h5'>Admin Updates</h2>
            </div>
            <div className='cb-margin-bottom-32' />
            <div>
                <h3 className='cb-h6 cb-margin-bottom-8'>CDS Status</h3>
                <p>{orgDetail?.cdsStatus||NOTAVAILABLE}</p>
            </div>
        </div>
      </div>

      <div className='cb-padding-left-48 cb-padding-right-48'>
        <div className='cb-border-bottom cb-margin-top-16 cb-margin-bottom-16' />
      </div>

      <div className='row cb-padding-left-48 cb-margin-bottom-24' >
        <div>
          <div>
            <h2 className='cb-h5'>ASC Updates</h2>
          </div>
          <div className='cb-margin-bottom-32' />
          <div>
            <div>
              <h3 className='cb-h6 cb-margin-bottom-8'>Last ASC Updated By HED User</h3>
              <p>{orgDetail?.hedBFCPDate?`${dateAndTimeFormatter(orgDetail?.hedBFCPDate)}`: NOTAVAILABLE}</p>
            </div>
            <div className='cb-margin-bottom-16' />

            {newroles[0]===ADMIN_ROLE &&
            <>
              <div>
                <h3 className='cb-h6 cb-margin-bottom-8'>Last ASC Updated By Admin User</h3>
                <p>{orgDetail?.adminBFCPDate?`${dateAndTimeFormatter(orgDetail?.adminBFCPDate)}`: NOTAVAILABLE}</p>
              </div>
              <div className='cb-margin-bottom-16' />
              <div>
                <h3 className='cb-h6 cb-margin-bottom-8'>Last ASC Updated By</h3>
                <p>{orgDetail?.lastBFCPUser||NOTAVAILABLE}</p>
              </div>
              <div className='cb-margin-bottom-16' />
            </>
            }
          </div>
        </div>

        <div className='col-sm-4'/>
          <div>
          <div>
            <h2 className='cb-h5'>APCP Updates</h2>
          </div>
          <div className='cb-margin-bottom-32' />

          <div>
            <div>
            <h3 className='cb-h6 cb-margin-bottom-8'>Last APCP Updated By HED User</h3>
              <p>{orgDetail?.hedAPCPDate?`${dateAndTimeFormatter(orgDetail?.hedAPCPDate)}`: NOTAVAILABLE}</p>
            </div>
            <div className='cb-margin-bottom-16' />

            {newroles[0]===ADMIN_ROLE && <>
            <div>
            <h3 className='cb-h6 cb-margin-bottom-8'>Last APCP Updated By Admin User</h3>
              <p>{orgDetail?.adminAPCPDate?`${dateAndTimeFormatter(orgDetail?.adminAPCPDate)}`: NOTAVAILABLE}</p>
            </div>
            <div className='cb-margin-bottom-16' />

            <div>
            <h3 className='cb-h6 cb-margin-bottom-8'>Last APCP Updated By</h3>
              <p>{orgDetail?.lastAPCPUser||NOTAVAILABLE}</p>
            </div>
            <div className='cb-margin-bottom-16' />
            </>}
          </div>
          </div>
        </div>
      </div>
  );
};

export default OrgDetail;